import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "SvetleÄa Å¡katla",
  "description": "",
  "published": "2007-07-12T00:00:00.000Z",
  "redirect_from": ["/blog/svetlea-katla/swizec/173"],
  "hero": "./img/1011-764794757_921f08be61_m.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pred nekaj dnevi sem v sluÅ¾bi prejel svetleÄo škatlico in seveda hotel o njej blogati takoj, a mi zaradi poplave dela nekako ni uspelo. Blogam torej sedaj s kopico grafiÄnega materiala.`}</p>
    <p>{`Takole izgleda popolnoma deviÄna neodprta škatla.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/swiz/764794757/",
        "title": "Photo Sharing"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "239px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'301\\'%20viewBox=\\'0%200%20400%20301\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20151v150h401V0H0v151M142%2047l-1%201c1%202-5%204-13%205l-8%201-9%204-1%202-2%202-2%201-2%201c-2%200-2%200-1-1l2-3-2%201-3%202c-2%200-8%208-7%2011%200%202%200%202-1%200s-1-2-4%203l-7%2012a1367%201367%200%2000-57%20108%203379%203379%200%2001117%2024%209973%209973%200%2000146%2029l53%209c13%202%2015%202%2014-1a604%20604%200%20017-90c1-1%203-95%202-100a3738%203738%200%2000-221-22m-24%2011c-3%201-4%204-3%207s9%203%2012-1c4-5-1-9-9-6M86%20234c-7%202-8%204-2%204h2l-2%202c0%201%206%205%209%205l6%201%205%202%208%202%2011%203%2011%202c1%201%203%202%208%202l4%201%202%201c2-1%206%202%206%204s0%202%201%201c2-2%202-2%205-1h5c2-1%203%200%206%203l3%205%201%201%201-1c0-2%201-2%204-2l5-2h3l5%201%208%202a70%2070%200%200010%203h5l12%203a245%20245%200%200127%205%20369%20369%200%200130%207l6%201%2024%203%208%201%205%201%204%201c2%202%204%200%203-3%200-1%200-2%201-1l5%203c4%202%204%202%204%200-2-5-6-11-8-11l-7-2-7-1-3-1-4-1a772%20772%200%2001-43-9%20231%20231%200%2000-34-6l-8-2-7-1a96%2096%200%2000-25-5l-3-1-4-1-6-1h-4c2-1%202-1-2-1l-15-3h-5c-3%200-3%200-2-1s0-1-4-1a832%20832%200%2001-44-8c-3-1-5%200-6%203%200%203%200%203-2%202-2%200-2-1-2-4%201-3%201-3-1-3l-1%202c0%202-2%203-6%202l-2-1h2c2%200%205-3%203-4l-3-1h-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/617778736f633ccdf4c3ec66645ed647/ca0a1/1011-764794757_921f08be61_m.webp 223w", "/static/617778736f633ccdf4c3ec66645ed647/0fcac/1011-764794757_921f08be61_m.webp 239w"],
                "sizes": "(max-width: 239px) 100vw, 239px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/617778736f633ccdf4c3ec66645ed647/853b2/1011-764794757_921f08be61_m.jpg 223w", "/static/617778736f633ccdf4c3ec66645ed647/e5db7/1011-764794757_921f08be61_m.jpg 239w"],
                "sizes": "(max-width: 239px) 100vw, 239px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/617778736f633ccdf4c3ec66645ed647/e5db7/1011-764794757_921f08be61_m.jpg",
                "alt": "100_0276",
                "title": "100_0276",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`100_0276`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Potem razkaÅ¾e svojo puhasto notranjost in obelodani dejstvo, da je promocijski material vedno v velikih paketih.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/swiz/764794807/",
        "title": "Photo Sharing"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "239px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'301\\'%20viewBox=\\'0%200%20400%20301\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2076v76l12-11c22-22%2022-22%2024-21v-1c0-2%2020-22%2022-22v-1l1-1c3%201%207%200%207-2l2-1%201-1c0-2%203-4%206-3s6%204%206%206l1%202c1%200%200-11-2-13s-1-4%202-3c2%200%203%200%202-1-2%200-3-2%200-2l1%201c0%202%202%201%204-1l3-2c2%200%206%204%204%205l-3%204c-1%202-2%205-4%206l-4%208-3%207-2%204-1%203-5%208-4%208a337%20337%200%2000-17%2030l-11%2020-2%205-1%202-2%204-1%203c-1-1-4%202-4%205l-2%204-4%208-1%201-1%202%201%201h4a461%20461%200%200087%2018%202956%202956%200%2001120%2022%203616%203616%200%2000123%2019c11%202%2011%202%2011-12a1684%201684%200%2000-3-164l-2%205c-1%201-1%201-1-2%201-4-1-5-6-1-7%205-11%204-12-2l-2-5h-2c-1-1-4%200-7%203-1%201-3%203-6%203-4%202-6%201-6-3%200-2-3-6-5-6l-6%203-7%204c-4%201-4%201-4-2l-6-8-5%204-6%203h-3c-1%202-3%201-3-2-1-5-5-8-8-7l-4%204c-3%202-4%203-5%202h-2c-2%202-3%201-5-3-3-7-7-8-11-2-2%203-3%204-4%203l-3-1c-2%201-3%200-5-4-2-3-3-4-5-4l-3%201-2%203c-4%205-9%203-12-3-3-5-6-6-8-2-4%207-10%208-13%201l-1-5c1-2-5%200-8%203l-3%203-3-2c-2-3-3-6%200-4h2c1-1%201-1%201%201s0%202%201%200l1-2%202-1%202-1-2-1h-2c-1-1%200-1%202-1%201%200%202%200%201-1l-13-1-13-1a317%20317%200%2000-43-4c-3%200-3%201-6%204l-3%204V0H0v76M152%201v21l3%204%203%202c3%202%2020%202%2025%200s5-3%205-17l1-11h-19l-18%201m219%201a1781%201781%200%2000-11%2071l-1%205%201-4%202-5%201-4c0-2%200-3%201-2l1%202c0%203%200%203%204%202l5-2c3-2%204-1%204%201%200%204%201%204%204%202s6-1%203%201l-1%202h9l2%203%202%202h-2l-3-2-2-1c-1%201%201%204%204%206%206%203%206%203%206-40V0h-14c-15%200-15%200-15%202M199%20110c-4%2010-5%2015-3%2015l8%205c9%206%2011%206%2018%200%203-3%205-2%209%204%205%207%209%207%209%200l2-11c2-11%202-11-9-13l-19-3c-13-2-13-2-15%203m-51%2021l-13%2022c-3%205-3%209%200%2010a377%20377%200%200033%202l2-2c0-1%203-9%207-15%207-14%206-16-6-17l-14-1c-6-1-7-1-9%201m100%2010c-2%202-9%2029-9%2034%200%204%206%206%2027%2010%207%201%209%201%2011-1%202-1%202-2%204-12%203-24%203-24%202-26-1-1-28-7-33-7l-2%202m-88%201l-5%201c-3%201-8%204-8%206l5%202c9%202%2017-1%2016-6l-3-2h-3l-2-1m41%204c-2%201-9%2021-8%2022l2-1c2-2%205-1%2011%205l8%205c3%200%207-4%208-9a1593%201593%200%20015-19c-2-1-24-4-26-3m56%209c-3%201-5%203-5%206l1%202h1l4%203c5%202%205%202%2010%201%205-2%206-4%204-8-3-3-11-6-15-4M22%20216v2c-1%201%203%206%208%2011%208%207%2010%209%2015%2010a623%20623%200%200074%2015h5l-4-1-4-1h16c4%202%204%202%2018%201%2014-2%2018-2%2021%200h13l9%201h5l-3-2h5c3%200%204%200%203%201-2%201-2%201%202%201%202%200%203%200%202-1l-2-1-18-3c-2%200-3%200-2-1l-2-1a1447%201447%200%2001-124-24%20494%20494%200%2001-37-7M0%20271v30h99l-4-2a21192%2021192%200%2000-94-58l-1%2030m312-1l7%202v1c-2%202-1%204%201%203%201-1%202%200%203%201l6%203c4%200%204%200%204%203%200%202-1%204-4%205h3l4-1c1-2%202-1%202%201-1%203%205%205%206%203h1c0%202-1%202-6%202s-5%200-1%201h5l3%201c1%202%2011%202%2014%200%204-4%2011-13%2011-16s0-3-13-4a836%20836%200%2000-46-6h-6l6%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/275afc969266e68e89853921ba8f0137/ca0a1/1312-764794807_ec57bcb4fd_m.webp 223w", "/static/275afc969266e68e89853921ba8f0137/0fcac/1312-764794807_ec57bcb4fd_m.webp 239w"],
                "sizes": "(max-width: 239px) 100vw, 239px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/275afc969266e68e89853921ba8f0137/853b2/1312-764794807_ec57bcb4fd_m.jpg 223w", "/static/275afc969266e68e89853921ba8f0137/e5db7/1312-764794807_ec57bcb4fd_m.jpg 239w"],
                "sizes": "(max-width: 239px) 100vw, 239px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/275afc969266e68e89853921ba8f0137/e5db7/1312-764794807_ec57bcb4fd_m.jpg",
                "alt": "100_0279",
                "title": "100_0279",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`100_0279`}</figcaption>{`
  `}</figure></a></p>
    <p>{`ZvoÄniki so z mojim telefonom igrali odliÄno in vsi skupaj so se na splošno odliÄno razumeli. Vsakomur s takim telefonom toplo priporoÄam prenosne miniaturne zvoÄnike.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/swiz/764794957/",
        "title": "Photo Sharing"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "239px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'301\\'%20viewBox=\\'0%200%20400%20301\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2032l1%2032%2020-17c22-18%2020-17%2021-15l3%202%202%202c1%201%201%201%201-1l1-2c1%200%202-1%201-2l-2-1v-1c0-2%200-2-2%200l-3%202c-1-1%206-7%207-7l4%201h3l-2-2-3-2%204-3c4-3%205-4%205-1h2v-2l-2-1%202-1h1l2%201v-1c-2-2-2-2%201-4l4-2%201-1%201-2%201%202%201%201%201-1%202-3h2c0%202%203%203%204%201%202-4-1-4-43-4H0v32M186%200c0%2010%2027%2018%2042%2012l6-2c1%200%204-2%206-5l4-4-9-1-10%201v2l1%202%202%202c3%200%200%202-5%203-7%202-11%202-16%201-3-1-4-3-2-3l1-4V0h-20m162%201l12%203h4a173%20173%200%200032%205l2%202c2%201%202%201%202-5V0h-26l-26%201M187%2031c-2%202-3%208-5%2041l-1%2014c-1%202%200%2033%201%2035s7%205%207%203c1-12%201-11%2022-11%2017%201%2018%201%2018%209%200%205%200%205%205%202%205-2%206-10%205-39l-1-37c0-15%200-16-4-16-9-2-46-2-47-1m97%2069l1%202v6l-2%204c0%206-1%207-5%201-3-5-9-8-11-6-1%201-1%201%201%201%204%200%2010%206%2014%2014%201%202-1%206-2%206s-2%201-2%205%201%204%203%204l2%201%202%203%201%203%201%202%203%205%201%205c2%203%201-4-1-9-3-6-2-7%201-5%205%202%205%201%202-2-2-1-3-2-2-3v-4l-2-4c-1-2-1-3-3-3-3%200-4-4-2-5l1-6c0-3%200-5%202-6l1-5c-1-5-2-8-4-4M48%20120c-22%204-22%204-24%2018-2%2015%201%2028%2011%2048l2%206%202%202c2%202%201%201-5-17-12-33-12-34%200-36%2036-8%2040-8%2043-8%204%201%204%201%2013%2034l4%2014c2%202%201%200-2-11l-3-13c-3-11-3-10%204-13%2013-6%2020-5%2027%203l4%208c0%205%203%208%204%204l2-2v2l1%202h1l-2%203-1%203c1%201%201%201%203-1l2-3%201-2%201-3%202-4c1-1%201-1-1-1-2%201-2%201-2-1%201-2-1-4-5-4l-4-2-7-5-4-1c-6-4-12-3-23%202-3%201-5%202-6%201l-7-22-3-3c-3-3-9-3-28%202m296%204c-3%201-4%202-7%2014l-5%2012v2l-2%2012-1%2012%201-2%201-6%203-12c0-5%202-10%203-12s7-4%2011-3l9%202c40%206%2038%206%2036%2017a482%20482%200%2001-9%2041l6-20c6-19%207-23%205-38-2-12-4-14-16-16a8910%208910%200%2001-35-3m-65%2017c-4%204-8%205-20%207-27%203-28%203-31%206l-3%203h-15c-18-1-19-1-22-5-2-3-10-4-17-3-8%201-7%202%201%202%2011%200%2016%202%2016%205%200%205%201%205%2020%206s21%200%2021-5c0-2%201-3%203-3%206-2%2015-3%2020-3%2011%200%2025-5%2029-9%202-3%200-3-2-1M74%20164c0%202-1%202-3%201-6-2-9-1-16%202-6%203-6%203-8%202-1-3-2-2-1%201%202%209%2023%209%2028%201%202-3%203-7%201-7h-1m270%2011c0%2011%2030%2012%2031%201%200-3%200-3-1-2l-2%203h-4c-6-5-9-5-15-4h-8c-1-1-1-1-1%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ab48590534eb2b540fe5b9ec752ce79e/ca0a1/1418-764794957_9958dfbad7_m.webp 223w", "/static/ab48590534eb2b540fe5b9ec752ce79e/0fcac/1418-764794957_9958dfbad7_m.webp 239w"],
                "sizes": "(max-width: 239px) 100vw, 239px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ab48590534eb2b540fe5b9ec752ce79e/853b2/1418-764794957_9958dfbad7_m.jpg 223w", "/static/ab48590534eb2b540fe5b9ec752ce79e/e5db7/1418-764794957_9958dfbad7_m.jpg 239w"],
                "sizes": "(max-width: 239px) 100vw, 239px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ab48590534eb2b540fe5b9ec752ce79e/e5db7/1418-764794957_9958dfbad7_m.jpg",
                "alt": "100_0280",
                "title": "100_0280",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`100_0280`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/swiz/764795045/",
        "title": "Photo Sharing"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "239px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'301\\'%20viewBox=\\'0%200%20400%20301\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20113v114h5l8-1%203-2h-3c-2%200-2%200%201-1s5%200%203%201v1c2%200%203-2%204-5l2-4%201-2c0-3%203-9%205-10%204-2%2052-4%2061-2%206%201%2017%202%2025%200l5%201c-1%201%200%201%204%201l5-1c1-2%206-1%206%200l2-1c1-1%202-2%204-1l1-1c-1-1%200-2%201-3l1-3c0-1%201-2%204-2%206-2%2012%200%2012%202l3%203%206%201c4%202%2014%202%2019%200l19-2c14%200%2014%200%2016%202s2%202%2015%202l15%201h16l4%201c2%202%202%202%205%200%202-1%202-2%201-2v-1h4l3-1-1-1-2-1%202-1c2%200%205%202%205%204h2c2%200%202%200%202%202l1%203%201-2%209-1h9v-1l-2-1h2c2%201%202%200%205-3%204-5%205-8%204-8l1-1c6-3%201-4-14-4l-16-1c-4-1-3-2%2013-2h18l1-4c0-10%203-6%203%206%201%2010%202%2014%205%2015a476%20476%200%200057%202l4%201h5v13l1-100V0H0v113M351%205c-2%200-3%201-2%202h1c1-1%2014%200%2014%201%200%204-4%206-9%207l-8%201-2-1h-9c1%201%200%202-1%201-2%200-2%200-1%201%202%201%200%202-3%202l-3%201-1%201-3%202-5%201-4%202c0%204%201%204%2012%203a1659%201659%200%200164-6l-1-8c0-6%200-7-2-5%200%202-1%202-1%201h-3l-4-1-4-1-4-1-5-1c-3-2-11-3-16-2M202%2038l-1%2025c0%2015%200%2018%203%2016V34c-1-8-2-6-2%204m20%205c-4%200-4%201-1%204l3%202-3%201c-5%202-2%203%209%203%2010%200%2010-1%208-2-3-1-3-1-2-2v-1l-1-2c-1-1%200-2%201-2l1-1h-15m-74%2017v4c3%2017%204%2020%202%2020l-1-3c0-5-2-9-4-8-4%201-4%202-3%206%202%205%202%205%200%205a3876%203876%200%20011%2034l1-4%201%204c0%203%201%204%202%205l2%206c1%204%201%204-1%205-5%202-5%201-5-4v-5c-2%200-2%2013-1%2014h3c0-2%203-3%204-2l-2%202c-3%202-3%203%200%203h2c1%201%207%201%208-1%200-2-3-3-4-1s-3-1-2-3v-4c0-2%200-3%201-2%201%202%207%200%207-2v-1l1-2%203-2h3v-8l-1-8h-1l-6-1-6-2h13c1%201%201%200%201-3%200-1%203-2%204-1h1l1%201%202%204c2%202%203%200%201-4l-2-3-1-4v-3c1-1%201-6-1-6-5-2-10-2-14-2l-4-1c1-3-2-22-3-23-2-2-2-2-2%200m246%204l-18%202c-34%202-36%202-35%203l8%201c7%200%208%201%209%202%201%202%201%202%203%201h8l-2%201c-4-1-3%202%200%203l4%203h1c3-1%203%204%203%2025v11h9v-9c1-13%202-14%206-15l7-1h3V64h-6m-69%2039l-1%209c2%2012%203%2019%203%2030%200%2013%201%2011%202-5l3-16c1-2%202-5%201-7%200-2%200-2%203-3%206-1%204-3-2-2l-3-3c-1-8-3-9-6-3m14%2015l-5%203-2%202v34l1%2034%202%203c3%202%203%202%2027%202h24l3-3%203-3v-32c-1-34-1-37-5-39-2-1-42-2-48-1m-287%203c-29%201-29%201-29%2017l3%2057c2%205%204%205%2026%205%2029-1%2029-2%2031-6%203-4%201-63-1-68-2-3-7-6-9-6l-21%201m56%2014v13l2-3c7-9%208-18%202-22-4-2-4-1-4%2012m129-9c-2%201%201%202%207%202%209%200%209%201%200%202-5%200-5%201-4%202%202%202%202%202-1%202-2%200-2%200-2-2%201-2%200-2-1-3-1%200-2-1-1-2%200-1-1-1-4%201-5%203%200%207%2010%208%207%200%209-1%2014-3%202-1%202-4-1-6-4-1-16-3-17-1m-38%2016l-1%207v8h9c3-1%203-1%202-7l-1-8h-9m158%201c-16%208-11%2032%207%2030%2016-2%2019-24%204-30-5-2-7-2-11%200m1%202c-4%201-4%203-1%202h3l-3%202-2%201%202%202c2%202%203%203%202%205%200%205%205%208%209%205%202-1%203-5%201-7-2-1%200-2%203-2%202%201%203%200%201-3-3-6-10-8-15-5m-298%207v2l-2%202c-2%201-3%204-1%204s1%204-1%206c-4%202-7%200-7-4%201-3%201-4-2-5-7-2-8%201-6%208l1%205c-3%202%206%206%2012%206%207%200%209-1%2013-7%205-7-1-21-7-17m127%2013c-2%202-3%203-3%205%200%203%200%204-2%204-4%201-3%202%201%201l4%201a386%20386%200%200067%201h5c7-1-11-3-22-2h-11v-3c0-3%200-4-2-4l-2-3c0-2-5-3-8-1h-18c-2-1-5-1-9%201m-20%2016c-1%202-8%205-11%205l-3-2-1-2v1l-1%201-1%202c0%203-14%201-16-2l-1%203-2%208c-1%203%200%204%202%201l2-3%201-3c1-3%201-3%204-1%206%202%2013%201%2023-3%203-1%208-6%206-6l-2%201m14%20108l-15%202-4%202-2%202-4%201c-4-1-18%201-34%203-6%202%205%202%2090%202%2094%200%20103%200%2083-3a626%20626%200%2001-57-9h-57\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2efe2845881f382c978ae43e324300be/ca0a1/1339-764795045_cecf0437de_m.webp 223w", "/static/2efe2845881f382c978ae43e324300be/0fcac/1339-764795045_cecf0437de_m.webp 239w"],
                "sizes": "(max-width: 239px) 100vw, 239px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2efe2845881f382c978ae43e324300be/853b2/1339-764795045_cecf0437de_m.jpg 223w", "/static/2efe2845881f382c978ae43e324300be/e5db7/1339-764795045_cecf0437de_m.jpg 239w"],
                "sizes": "(max-width: 239px) 100vw, 239px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2efe2845881f382c978ae43e324300be/e5db7/1339-764795045_cecf0437de_m.jpg",
                "alt": "100_0281",
                "title": "100_0281",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`100_0281`}</figcaption>{`
  `}</figure></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      